import { Currencies } from '@shared/utils/constants';
import { formatCurrency } from '@shared/utils/currency';
import { Values } from '@shared/utils/objectEnums';

export const formatEuEtsEmissionCost = (
	euaPrice: number | null | undefined,
	factorAdjustedEligibleEmissions: number | null | undefined,
	currency: Values<typeof Currencies>,
) => formatCurrency(
	(Number(euaPrice) || 0) * (Number(factorAdjustedEligibleEmissions) || 0),
	currency,
);
